import { Grid, Typography } from '@mui/material';
import { convertsCentsToCurrency } from '@npi/buddy-utils';

interface SummaryOrderItemsProps {
    order: {
        oneOffPrice: number;
        monthlyPrice: number;
        quantity: number;
        description: number;
    };
    currency: string;
    contractTerm: number;
}

const SummaryOrderItems = ({ order, currency, contractTerm }: SummaryOrderItemsProps) => {
    const serviceOrder = order;

    const getTotal = () => {
        const productOrderOneOffPrice = serviceOrder.oneOffPrice;
        const productOrderMonthlyPrice = serviceOrder.monthlyPrice;
        const termOrderMonthlyTotal = contractTerm * productOrderMonthlyPrice;

        const total = convertsCentsToCurrency(
            (productOrderOneOffPrice + termOrderMonthlyTotal) * serviceOrder.quantity
        );

        return total.toFixed(2);
    };

    return (
        <>
            {/* Product name */}
            <Grid item xs={3} alignSelf="center">
                <Typography fontSize="13px" color="#1D1D1B" textAlign="start">
                    {serviceOrder.description}
                </Typography>
            </Grid>

            {/* Setup, QTY, Monthly Rental, Total */}
            <Grid item xs={2} bgcolor="#F9FAFB">
                <Typography fontSize="13px" color="#1D1D1B" textAlign="center" marginLeft={'16px'}>
                    {`${currency} ${convertsCentsToCurrency(serviceOrder.oneOffPrice ?? 0)}`}
                </Typography>
            </Grid>
            <Grid item xs={2} bgcolor="#F9FAFB">
                <Typography fontSize="13px" color="#1D1D1B" textAlign="center" marginLeft={'16px'}>
                    {serviceOrder.quantity}
                </Typography>
            </Grid>
            <Grid item xs={2} bgcolor="#F9FAFB">
                <Typography fontSize="13px" color="#1D1D1B" textAlign="center" marginLeft={'16px'}>
                    {`${currency} ${convertsCentsToCurrency(serviceOrder.monthlyPrice ?? 0)}`}
                </Typography>
            </Grid>
            <Grid
                item
                xs={2}
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor="#F9FAFB"
            >
                <Typography fontSize="16px" color="#1D1D1B" textAlign="center">
                    {`${currency} ${getTotal()}`}
                </Typography>
            </Grid>
        </>
    );
};
export default SummaryOrderItems;
